import { LoginDTO } from "../../../../requests/login/types";
import { AError } from "../../../../requests/types";
import {
  REQUEST_LOGIN,
  GOOGLELOGIN_SUCCESS,
  GOOGLELOGIN_ERROR,
} from "../../actions";

// ----- REQUEST ----------------------------------------------------------
type RequestGoogleLogin = {
  type: typeof REQUEST_LOGIN;
};

export const requestGoogleLogin = (): RequestGoogleLogin => ({
  type: REQUEST_LOGIN,
});

// ----- SUCCESS ---------------------------------------------------------
type SuccessGoogleLogin = {
  type: typeof GOOGLELOGIN_SUCCESS;
  payload: {
    data: LoginDTO;
    isUserAdmin: boolean;
  };
};

export const successGoogleLogin = (
  data: LoginDTO,
  isUserAdmin: boolean
): SuccessGoogleLogin => ({
  type: GOOGLELOGIN_SUCCESS,
  payload: { data, isUserAdmin },
});

// ----- ERROR -----------------------------------------------------------
type ErrorGoogleLogin = {
  type: typeof GOOGLELOGIN_ERROR;
  errors: { error: AError };
};

export const errorGoogleLogin = (error: AError): ErrorGoogleLogin => ({
  type: GOOGLELOGIN_ERROR,
  errors: { error },
});

export type GoogleLoginActions =
  | RequestGoogleLogin
  | SuccessGoogleLogin
  | ErrorGoogleLogin;
